import {createRouter, createWebHistory} from 'vue-router'
import {useAccountStore} from "@/stores/account.store.ts";
import accountRoutes from "@/router/routes/account.routes.ts";
import synchroRoutes from "@/router/routes/synchro.routes.ts";
import failureRoutes from "@/router/routes/failure.routes.ts";
import {PublicRouteList, RouteEnum} from "@/router/RouteEnum.ts";
import fusionRoutes from "@/router/routes/fusion.routes.ts";
import createRoutes from "@/router/routes/create.routes.ts";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '',
      redirect: RouteEnum.Login
    },
    ...accountRoutes,
    ...fusionRoutes,
    ...synchroRoutes,
    ...failureRoutes,
    ...createRoutes
  ]
})

router.beforeEach(async (to, from, next) => {
  if (undefined === to.name) {
    next({
      name: RouteEnum.NotFound
    })
    return Promise.resolve()
  }
  const isPublic = PublicRouteList.includes(to.name as RouteEnum);

  if (useAccountStore().isLogged()) {
    if (isPublic) {
      next({
        name: RouteEnum.Dashboard
      })
    } else {
      next()
    }
    return Promise.resolve()
  }

  if (!isPublic) {
    useAccountStore().originRoute = to
    next({
      name: RouteEnum.Login
    })
    return Promise.resolve()
  }

  next()
  return Promise.resolve()


})


export default router
